import { Box, Divider, Group, Title } from '@mantine/core';

import { DeclarationGoods } from '@e-origin/shared';

import { InputsComparator } from '@components';
import { FormatValueTypes } from '@enums';
import { formatValue } from '@utils';

interface RiskAnalysisOthersProps {
  goodDetails: DeclarationGoods;
}

export const RiskAnalysisOthers: React.FC<RiskAnalysisOthersProps> = ({ goodDetails }) => {
  const invoicedItemWeight = formatValue(
    goodDetails.evalMethodWebValue?.invoicedMassCoefficient ? 1 / goodDetails.evalMethodWebValue.invoicedMassCoefficient : 0,
    FormatValueTypes.KG,
  );

  const webWeight = formatValue(Number(goodDetails.evalMethodWebValue?.webWeight || 0), FormatValueTypes.KG);

  const ratioToCheck = !!goodDetails.evalMethodAiHsCode?.taricRatioToCheck;

  const invoicedNetWeightPerUnit = formatValue(goodDetails.evalMethodAiHsCode?.calculatedRatio || 0, FormatValueTypes.KG);

  const getTaricNetWeightPerUnit = () => {
    const measureFound = (goodDetails.evalMethodAiHsCode?.taricOtherMeasures || []).find(
      (measure) => measure.measureType === 'Declaration of subheading submitted to physical restrictions (net weight/supplementary unit)',
    );

    return (
      (measureFound || (goodDetails.evalMethodAiHsCode?.taricOtherMeasures || [])[0])?.duty
        ?.replace('Cond: ', '')
        ?.replace('B cert:', '')
        ?.replace('C cert:', '')
        ?.replace('Y cert:', '')
        ?.trim() || ''
    );
  };
  const taricNetWeightPerUnit = getTaricNetWeightPerUnit();

  const isWebWeightOk = () => {
    return goodDetails.evalMethodWebValue?.webWeightOk === undefined || !!goodDetails.evalMethodWebValue.webWeightOk;
  };

  return (
    <>
      <Group px="md">
        <Title order={6} fw={600}>
          Others
        </Title>
      </Group>

      <Divider mt="sm" mb="lg" />

      <Box px="lg">
        <InputsComparator
          title="Invoiced item weight"
          placeholders={['Invoiced item weight', 'Web item weight']}
          values={[invoicedItemWeight, webWeight]}
          badge={
            !isWebWeightOk() && {
              status: 'error',
              text: '',
            }
          }
          disabled={[true, true]}
        />

        {ratioToCheck && (
          <>
            <Divider mt="md" />
            <InputsComparator
              title="Ratio"
              placeholders={['Invoiced net weight per unit', 'TARIC net weight per unit']}
              values={[invoicedNetWeightPerUnit, taricNetWeightPerUnit]}
              disabled={[true, true]}
            />
          </>
        )}
      </Box>
    </>
  );
};
